import React from "react";

export const CurrentSavedMoviesContext = React.createContext();
